const Dcards = [
    {
        imgsrc1: "https://cdn.sanity.io/images/gxmub2ol/production/77f11e9393478c60b5ae6c22beec6791de73837c-800x611.jpg?fm=webp",
        title1: "VP - Finance",
        text1: "PANKAJ GHAI",
    },
    {
        imgsrc1: "https://cdn.sanity.io/images/gxmub2ol/production/72d133d7486895faa971077aef4a947a673f3ae2-800x623.jpg?fm=webp",
        title1: "CFO",
        text1: "VAIBHAV GOEL",
    },
    {
        imgsrc1: "https://cdn.sanity.io/images/gxmub2ol/production/32dfda0de825f79acde4b093f3a037d568b5a4e6-800x652.jpg?fm=webp",
        title1: "General Counsel",
        text1: "RAMANUJ GOPALAN",
    },
    {
        imgsrc1: "https://cdn.sanity.io/images/gxmub2ol/production/98094e7a0f86dd173f46e5bcf7738a5243a16127-6225x4055.jpg?w=960&fm=webp",
        title1: "VP - Talent Acquisition",
        text1: "KALLAN H",
    },
    {
        imgsrc1: "https://cdn.sanity.io/images/gxmub2ol/production/dca1dc73da5fc6880c08d2ffd7222b2d1e01055c-800x711.jpg?fm=webp",
        title1: "Finance Control",
        text1: "ANKUR JAIN",
    },
    {
        imgsrc1: "https://cdn.sanity.io/images/gxmub2ol/production/6eabca556e6ea0655b6b99480f3fad0c30a2b01b-6240x4160.jpg?w=960&fm=webp",
        title1: "VP - Community Development",
        text1: "PRIYA KALE",
    },
    {
        imgsrc1: "https://cdn.sanity.io/images/gxmub2ol/production/48108f4e848f1b7893b7040b4be3b529bac9899a-800x675.jpg?fm=webp",
        title1: "Deputy Finance Manager",
        text1: "MAMTA KALRA",
    },
];

export default Dcards;